import React from "react";
import "./CSAMFooter.css";
import Logo from "../Logo/CSAM1.png"; // ya png use karo

const CSAMFooter: React.FC = () => {
  return (
    <footer className="shivam-custom-footer1">
      <div className="shivam-footer-container">
        {/* ===== COLUMN 1 ===== */}
        <div className="footer-col">
          <img src={Logo} alt="Courier Addaa" className="shivam-footer-logo" />
          <p>
            <strong>C SAM SOLUTIONS PVT.LTD.</strong> As a newcomer in the
            transport sector, our company is built on the pillars of technology,
            efficiency, and eco-friendly practices, aiming to redefine how goods
            are moved across regions.
          </p>
        </div>

        {/* ===== COLUMN 2 ===== */}
        <div className="shivam-footer-col">
          <h5>Our Divisions</h5>
          <ul>
            <li>What We Do</li>
            <li>Request a Freight</li>
            <li>Track & Trace</li>
            <li>About Us</li>
            <li>Package Plan</li>
          </ul>
        </div>

        {/* ===== COLUMN 3 ===== */}
        <div className="footer-col">
          <h5>Our Services</h5>
          <ul>
            <li>Road Freight</li>
            <li> Freight</li>
            <li>Ocean Freight</li>
            <li>Rail Freight</li>
            <li>Air Freight</li>
          </ul>
        </div>

        {/* ===== COLUMN 4 ===== */}
        <div className="footer-col">
          <h5>Industry Sectors</h5>
          <ul>
            <li>What We Do</li>
            <li>Request a Freight</li>
            <li>Track & Trace</li>
            <li>Our Team</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* ===== COLUMN 5 ===== */}
        <div className="footer-col">
          <h5>Get in Touch</h5>
          <p>
            <i className="fas fa-map-marker-alt"></i>
            Gala No. 8 YASH COMPLEX, Plot No. C-1/B/37 1st Phase, Near Bharat Acid, GIDC, Vapi, Gujarat.
          </p>
          <p>
            <i className="fas fa-phone-alt"></i> +91-99988 06991
          </p>
          <p>
            <i className="far fa-envelope"></i>{" "}
            <a href="mailto:info@laxmicargo.com">csam.vapi@gmail.com</a>
          </p>
        </div>
      </div>

      {/* ===== COPYRIGHT STRIP ===== */}
      <div className="shivam-footer-bottom">
        <p>© 2023 C SAM SOLUTIONS PVT.LTD.| All rights reserved</p>

        <span>
          Powered by{" "}
          <a href="https://www.neotechnet.com" target="_blank" rel="noreferrer">
            Neotech IT Services
          </a>
        </span>

        <div className="shivam-footer-social">
          <a href="https://facebook.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-facebook-f"></i>
          </a>
          <a href="https://x.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-x-twitter"></i>
          </a>
          <a href="https://instagram.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-instagram"></i>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-linkedin-in"></i>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-youtube"></i>
          </a>
          <a href="https://wa.me/919998806991" target="_blank" rel="noreferrer">
            <i className="fa-brands fa-whatsapp"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default CSAMFooter;
